import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import React, { useEffect, useState } from 'react'
import PeopleIcon from '@mui/icons-material/People';
import { buscarClientesPorIdParcAssoc, buscarParceirosPorAssociados } from '../../../services/api-planejamento-tributario.service'
import VisibilityIcon from '@mui/icons-material/Visibility';
import GroupsIcon from '@mui/icons-material/Groups';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import styles from './styles.module.css'
import TableCard from '../../../components/TableCard';
import ModalVisualizar from '../ModalVisualizar';

const ModalFilhos = ({ open, onClose, dados, atualizaPai }) => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [openVisualizar, setOpenVisualizar] = useState(false)
  const [dadosVisualizar, setDadosVisualizar] = useState({})
  const [openFilhos, setOpenFilhos] = useState(false)
  const [dadosFilho, setDadosFilho] = useState({})
  const [dadosFiltrados, setDadosFiltrados] = useState([])

  useEffect(() => {
    dados && handleAtualizarDados()
  }, [dados])

  const handleAtualizarDados = async () => {
    setLoading(true)
    if (dados.title === 'Clientes') {
      const response = await buscarClientesPorIdParcAssoc(dados.pai, dados.idPai)
      setData(handleOrganizaDataCliente(response.cliente))
      setDadosFiltrados(handleOrganizaDataCliente(response.cliente))
    } else {
      const response = await buscarParceirosPorAssociados(dados.idPai)
      setData(handleOrganizaDataParceiro(response.parceiros))
      setDadosFiltrados(handleOrganizaDataParceiro(response.parceiros))
    }
    await atualizaPai()
    setLoading(false)
  }


const handleClick = (id, tipo, status) => {
  setDadosVisualizar({ id, tipo, status });
  setOpenVisualizar(true)
}

const handlePesquisaPorTexto = (value) => {
  const newValue = value.toLowerCase();

  const filtered = data.filter(item =>
    Object.keys(item).some(key =>
      item[key].toString().toLowerCase().includes(newValue)
    )
  );
  setDadosFiltrados(filtered);
}

const handleCloseVisualizar = () => {
  setOpenVisualizar(false)
}

const handleOpenFilhos = async (idPai) => {
  const response = await buscarClientesPorIdParcAssoc('P', idPai)
  setDadosFilho(handleOrganizaDataCliente(response.cliente))
  setOpenFilhos(true)
}

const handleCloseFilhos = () => {
  setOpenFilhos(false)
}


const handleOrganizaDataParceiro = (response) => {
  const data = response.map(item => {
    const btn = [
      item.status === 'ANALISANDO' ? { icon: <AttachMoneyIcon />, title: 'NEGOCIAR', onClick: () => handleClick(item.idusuario, 'Parceiro', 'N') }
        : { icon: <VisibilityIcon />, title: 'VISUALIZAR', onClick: () => handleClick(item.idusuario, 'Parceiro', 'V') },
      { icon: <GroupsIcon />, title: 'CLIENTES', onClick: () => handleOpenFilhos(item.id) },
    ]

    let novoStatus = ''
    switch (item.status) {
      case 'APROVADO':
        novoStatus = <span className={styles.status_container}>
          <span className={styles.aprovado} /> Aprovado
        </span>
        break;
      case 'ANALISANDO':
        novoStatus = <span className={styles.status_container}>
          <span className={styles.analise} /> Analisar
        </span>
        break;
      case 'REPROVADO':
        novoStatus = <span className={styles.status_container}>
          <span className={styles.reprovado} /> Reprovado
        </span>
        break;
      case 'PENDENTE-EDICAO':
        novoStatus = <span className={styles.status_container}>
          <span className={styles.reprovado} /> Revisando
        </span>
        break;

      default:
        break;
    }
    return {
      nome: item.nome ? item.nome : '-',
      cpf: item.cpf ? item.cpf : '-',
      cnpj: item.cnpj ? item.cnpj : '-',
      whatsapp: item.whatsapp ? item.whatsapp : '-',
      status: item.status ? novoStatus : '-',
      botoes: btn
    }
  })

  return data
}

const handleOrganizaDataCliente = (response) => {
  const data = response.map(item => {
    const btn = [item.status === 'ANALISANDO' ?
      { icon: <AttachMoneyIcon />, title: 'NEGOCIAR', onClick: () => handleClick(item.dadosCliente.id, 'Cliente', 'N') }
      : { icon: <VisibilityIcon />, title: 'VISUALIZAR', onClick: () => handleClick(item.dadosCliente.id, 'Cliente', 'V') }
    ]
    let novoStatus = ''
    switch (item.status) {
      case 'APROVADO':
        novoStatus = <span className={styles.status_container}>
          <span className={styles.aprovado} /> Aprovado
        </span>
        break;
      case 'ANALISANDO':
        novoStatus = <span className={styles.status_container}>
          <span className={styles.analise} /> Analisando
        </span>
        break;
      case 'REPROVADO':
        novoStatus = <span className={styles.status_container}>
          <span className={styles.reprovado} /> Reprovado
        </span>
        break;
      case 'PENDENTE-EDICAO':
        novoStatus = <span className={styles.status_container}>
          <span className={styles.revisando} /> Revisando
        </span>
        break;

      default:
        break;
    }
    return {
      nome: item.dadosCliente.nome ? item.dadosCliente.nome : '-',
      cpf: item.dadosCliente.cpf ? item.dadosCliente.cpf : '-',
      cnpj: item.dadosCliente.cnpj ? item.dadosCliente.cnpj : '-',
      whatsapp: item.dadosCliente.whatsapp ? item.dadosCliente.whatsapp : '-',
      status: item.status ? novoStatus : '-',
      botoes: btn
    }
  })

  return data
}

const optionsFilter = [
  { value: 'status: Aprovado' },
  { value: 'status: Recusado' },
  { value: 'status: Analisar' },
  { value: 'status: Revisando' },
]

const columns = [
  'Nome', 'CPF', 'CNPJ', 'WhatsApp', 'Status'
]


return (
  <>
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='xl'
      fullWidth
    >
      <DialogContent>
          <TableCard
            iconHeader={dados.title === 'Clientes' ? <GroupsIcon fontSize='2rem' /> : <PeopleIcon fontSize='2rem' />}
            titleHeader={dados.title}
            optionsFilter={optionsFilter}
            data={dadosFiltrados}
            setData={setDadosFiltrados}
            columns={columns}
            loading={loading}
            textHeaderCard='nome'
            handleDebounce={handlePesquisaPorTexto}
          />
      </DialogContent>
      <DialogActions className={styles.btnContainer}>
        <Button variant="outlined" onClick={onClose} className={styles.btnFechar}>Fechar</Button>
      </DialogActions>
    </Dialog>
    <ModalVisualizar
      open={openVisualizar}
      onClose={handleCloseVisualizar}
      dadosUsuarios={dadosVisualizar}
      atualizarDados={handleAtualizarDados}
    />
    <Dialog
      open={openFilhos}
      onClose={handleCloseFilhos}
      maxWidth='xl'
      fullWidth
    >
      <DialogContent>
        <TableCard
          iconHeader={<GroupsIcon fontSize='2rem' />}
          titleHeader='Clientes'
          optionsFilter={optionsFilter}
          data={dadosFilho}
          setData={setDadosFilho}
          columns={columns}
          textHeaderCard='nome'
          handleDebounce={handlePesquisaPorTexto}
        />
      </DialogContent>
      <DialogActions className={styles.btnContainer}>
        <Button variant="outlined" onClick={handleCloseFilhos} className={styles.btnFechar}>Fechar</Button>
      </DialogActions>
    </Dialog>
  </>
)
}

export default ModalFilhos